import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

const Catalogo        = lazy(() => import("../pages/catalogo/page"));
const ProductPage     = lazy(() => import("../pages/product/page"));
// const ArmaTuPcPage    = lazy(() => import("../pages/arma-tu-pc/page"));
const ServiciosPage   = lazy(() => import("../pages/servicios/page"));
const NosotrosPage    = lazy(() => import("../pages/nosotros/page"));
const AgendarPage     = lazy(() => import("../pages/agendar/page"));
const SeguimientoPage = lazy(() => import("../pages/seguimiento/page"));

const Loader = () => (
  <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-2 border-red-600 border-t-transparent rounded-full animate-spin" />
      <span className="text-zinc-500 text-xs font-bold uppercase tracking-widest">Cargando...</span>
    </div>
  </div>
);

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  {
    path: "/catalogo",
    element: <Suspense fallback={<Loader />}><Catalogo /></Suspense>,
  },
  {
    path: "/catalogo/:companyId/:productId",
    element: <Suspense fallback={<Loader />}><ProductPage /></Suspense>,
  },
  // {
  //   path: "/arma-tu-pc",
  //   element: <Suspense fallback={<Loader />}><ArmaTuPcPage /></Suspense>,
  // },
  {
    path: "/arma-tu-pc",
    element: <Suspense fallback={<Loader />}><Home /></Suspense>,
  },
  {
    path: "/servicios",
    element: <Suspense fallback={<Loader />}><ServiciosPage /></Suspense>,
  },
  {
    path: "/nosotros",
    element: <Suspense fallback={<Loader />}><NosotrosPage /></Suspense>,
  },
  {
    path: "/agendar",
    element: <Suspense fallback={<Loader />}><AgendarPage /></Suspense>,
  },
  {
    path: "/seguimiento",
    element: <Suspense fallback={<Loader />}><SeguimientoPage /></Suspense>,
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
